import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-brand-detail',
  templateUrl: './brand-detail.component.html',
  styleUrls: ['./brand-detail.component.css']
})
export class BrandDetailComponent implements OnInit {

  constructor(private brandService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  output:any=[]; //---store get() result--------
  brandId='';
  //getUrl='http://192.241.151.66:5000/viewBrands';
  imgUrl=this.brandService.ReturnBase();
  name=""

  //------routing to edit page--------------------
   EditBrands(){
    this.router.navigateByUrl(('admin/edit-brand'));  
  }
  
  //--------function which give id of selected customer---------
  getValue(){
    this.brandService.setBrandId(this.brandId)
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  ngOnInit(): void {

        //---call function in service for brand Id------
        this.brandId=this.brandService.getBrandId()
       
       //-------api get()calling-------------
       this.brandService.ViewBrandById('/'+this.brandId).subscribe((res)=>{
       this.output=res.data
       this.name=this.output[0].brand_name
       this.imgUrl=this.imgUrl+this.output[0].brand_images

        
       })
  }

}
